<template>
  <div class="product-card" @click="goToProduct">
    <div class="product-image">
      <img :src="product.image || '/placeholder.jpg'" :alt="product.name">
      <div v-if="product.discount > 0" class="discount-badge">
        -{{ product.discount }}%
      </div>
      <button class="quick-add-btn" @click.stop="addToCart" aria-label="Add to cart">
        +
      </button>
    </div>

    <div class="product-info">
      <h3 class="product-name">{{ product.name }}</h3>
      <p class="product-description">{{ product.description }}</p>

      <div class="product-price">
        <span class="current-price">
          ${{ discountedPrice.toFixed(2) }}
        </span>
        <span v-if="product.discount > 0" class="original-price">
          ${{ product.price.toFixed(2) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    discountedPrice() {
      return this.product.price * (1 - (this.product.discount || 0) / 100)
    }
  },
  methods: {
    goToProduct() {
      this.$router.push(`/e-commerce-web/product/${this.product.id}`)
    },
    addToCart() {
      this.$store.dispatch('ecommerce/cart/addToCart', {
        productId: this.product.id,
        quantity: 1
      })
    }
  }
}
</script>

<style scoped>
.product-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.05);
}

.discount-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ff4757;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 14px;
}

.quick-add-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: background 0.3s ease;
}

.quick-add-btn:hover {
  background: #f8f9fa;
}

.product-info {
  padding: 15px;
}

.product-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #333;
}

.product-description {
  font-size: 14px;
  color: #666;
  margin: 0 0 12px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-price {
  display: flex;
  align-items: center;
  gap: 8px;
}

.current-price {
  font-size: 18px;
  font-weight: 700;
  color: #2ed573;
}

.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
}
</style>